// extracted by mini-css-extract-plugin
module.exports = {"sm":"LabelSize_sm__rbgZk","md":"LabelSize_md__jzEyx","lg":"LabelSize_lg__Lbid0","xl":"LabelSize_xl__yxrh1"};